// extracted by mini-css-extract-plugin
export default {"Logo":"BusinessSidebar_Logo__5p+xA","SidebarOffset":"BusinessSidebar_SidebarOffset__fghIc"};